// extracted by mini-css-extract-plugin
module.exports = {"block":"aaqpv","link":"PkJ7C","row":"msyML","subTitle":"TSAvG"};